// extracted by mini-css-extract-plugin
export default {"record-writebox":"BloodSugarWrite_record-writebox__GbYve","date-record":"BloodSugarWrite_date-record__HjUhm","time-record":"BloodSugarWrite_time-record__KGeiu"};